const getBearerToken = (): string => {
  const token = localStorage.getItem('authToken')

  return token ? JSON.parse(token).token : ''
}

export default getBearerToken
